import React from "react";
import { ExpertServiceType } from "../../../pages/expert/service/ExpertServiceNotice";
import ServiceNoticeTab from "./ServiceNoticeTab";
import TakerAgentNotice from "./TakerAgentNotice";
import TakerServiceAgreeMent from "./TakerServiceAgreeMent";
import { css } from "@emotion/react";
import { useState } from "react";
import TakerConsultNotice from "./TakerConsultNotice";
import { transferToNative } from "@src/lib/WebAppBridge";
import TakerBidAgentNotice from "./TakerBidAgentNotice";

const ServiceNoticeForExpert = ({ serviceType }: { serviceType: ExpertServiceType }) => {
    const [isAgree, setIsAgree] = useState(false);
    const handleClickNext = () => {
        transferToNative(JSON.stringify({ serviceType, userType: "taker" }), "closeServiceNotice");
    };
    return (
        <div>
            <ServiceNoticeTab userType="taker" serviceType={serviceType} />
            {serviceType == ExpertServiceType.경매대행 && <TakerAgentNotice />}
            {serviceType == ExpertServiceType.매물컨설팅 && <TakerConsultNotice />}
            {serviceType == ExpertServiceType.매수신청대리 && <TakerBidAgentNotice />}
            {/* {serviceType == ExpertServiceType.임장동행 && <TakerAccompanyNotice />} */}
            <TakerServiceAgreeMent onAllAgree={() => setIsAgree(true)} onDisAgree={() => setIsAgree(false)} />
            <div css={ButtonContainerStyle}>
                <button css={ButtonStyle(isAgree)} disabled={!isAgree} onClick={handleClickNext}>
                    다음
                </button>
            </div>
        </div>
    );
};

export default ServiceNoticeForExpert;

const ButtonContainerStyle = css`
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 14px 14px 24px 14px;
`;

const ButtonStyle = (isAgree: boolean) => css`
    width: 100%;
    padding: 14px 0;
    background-color: ${isAgree ? "#2275EE" : "#c3c3c3"};
    color: #ffffff;
    border-radius: 14px;
    font-size: 18px;
`;
